<header class="shadow-sm h-18 w-full">
<div class="flex items-center justify-between p-4">
    <div></div>

    <!-- User Section -->
    <div class="flex items-center ">
      <div class="mr-2 flex flex-col text-right">
        <div class="text-sm font-medium text-gray-800">{{ user?.firstName ?? '' }} {{user?.lastName ?? ''}}</div>
      </div>
      <app-avatar
        (click)="op.toggle($event)"
        [firstName]="user?.firstName ?? ''"
        [lastName]="user?.lastName ?? ''"
        [image]="user?.picture ?? ''"
      />
      <p-popover #op>
        <div class="flex flex-col p-2 w-48">
          @for (item of popOverData; track $index) {
            <div
              class="py-2 rounded hover:bg-gray-100 text-sm text-primary cursor-pointer transition"
              (click)="handlePopoverClick(item.action); op.hide()"
            >
              {{ item.label }}
            </div>
          }
        </div>
      </p-popover>
    </div>
  </div>
</header>
